import { render, staticRenderFns } from "./menuBackgroundImage.vue?vue&type=template&id=60bce4a6&scoped=true&"
import script from "./menuBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./menuBackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./menuBackgroundImage.vue?vue&type=style&index=0&id=60bce4a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bce4a6",
  null
  
)

export default component.exports